var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuExpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_menu_expand",
    transform: "translate(-342 -854)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 36,
    height: 36,
    rx: 12,
    transform: "translate(342 854)",
    fill: "#f3f4f4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    "data-name": "Path 6628",
    d: "M-1.024,1.482,4.9-4.425",
    transform: "translate(357.053 870.502)",
    fill: "none",
    stroke: "#242d46",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    "data-name": "Path 6627",
    d: "M-.994-5.21,4.925.7",
    transform: "translate(357.047 877.223)",
    fill: "none",
    stroke: "#242d46",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuExpand);
export default __webpack_public_path__ + "static/media/icon_menu_expand.b17f1fc9.svg";
export { ForwardRef as ReactComponent };